export const createTractorConfig = (selectOptions) => {
  return [
    {
      step_title: 'Identify',
      form_title: 'New Tractor',
      section: [
        {
          name: 'tractor_number',
          placeholder: 'Enter a Tractor Number',
          input: 'input',
          rules: [
            {
              required: true,
              message: 'Tractor Number is required',
            },
          ],
        },
        {
          name: 'depot',
          input: 'select',
          options: selectOptions.depots,
          placeholder: 'Select a depot',
          rules: [
            {
              required: true,
              message: 'Depot is required',
            },
          ],
        },
        {
          name: 'vin',
          input: 'input',
          placeholder: 'Enter a VIN',
          // add min length to InputField in excaliburr?
          rules: [
            {
              required: true,
              message: 'Depot is required',
            },
          ],
        },
        {
          name: 'make',
          input: 'input',
          placeholder: 'Enter make',
          rules: [
            {
              required: true,
              message: 'Make required',
            },
          ],
        },
        {
          name: 'model',
          input: 'input',
          placeholder: 'Enter model',
          rules: [
            {
              required: true,
              message: 'Model required',
            },
          ],
        },
        {
          name: 'year',
          input: 'inputNumber',
          placeholder: 'Enter year',
          min: 1900,
          max: 2100,
          rules: [
            {
              required: true,
              message: 'Year required',
            },
          ],
        },
        {
          name: 'weight',
          input: 'inputNumber',
          min: 100,
          placeholder: 'Enter weight',
          rules: [
            {
              required: true,
              message: 'Weight required',
            },
          ],
        },
      ],
    },
  ]
}
